import { useState } from 'react';
import { requests } from '../../../services/external/APIs';
import {
    ApproveLiquidatedOvertimeHoursRequest,
    PreliquidationHourSummaryRequest,
    RejectLiquidatedOvertimeHoursRequest,
    RequestLiquidatedOvertimeHourRequest,
} from '../models/requests';

export const useLiquidatedOvertimeHours = () => {
    const [isLoading, setIsLoading] = useState(false);

    const getLiquidatedOvertimeHours = async (
        model: RequestLiquidatedOvertimeHourRequest
    ) => {
        setIsLoading(true);

        return requests
            .post('/dublin/api/v1/liquidate/get-liquidated-overtime-hours', model)
            .then((res) => res)
            .catch((err) => {throw err})
            .finally(() => setIsLoading(false));
    };

    const approveOvertimeHours = async (
        model: ApproveLiquidatedOvertimeHoursRequest
    ) => {
        setIsLoading(true);

        return requests
            .post('/dublin/api/v1/liquidate/approve', model)
            .then((res) => res)
            .catch((err) => err)
            .finally(() => setIsLoading(false));
    };

    const rejectOvertimeHours = async (
        model: RejectLiquidatedOvertimeHoursRequest
    ) => {
        setIsLoading(true);

        return requests
            .post('/dublin/api/v1/liquidate/reject', model)
            .then((res) => res)
            .catch((err) => err)
            .finally(() => setIsLoading(false));
    };

    const modifyOvertimeHours = async (
        model: PreliquidationHourSummaryRequest,
        id: number
    ) => {
        setIsLoading(true);

        return requests
            .put('/dublin/api/v1/liquidate/hours/' + id, model)
            .then((res) => res)
            .catch((err) => err)
            .finally(() => setIsLoading(false));
    };

    const overtimeLiquidation = async (
        model: RequestLiquidatedOvertimeHourRequest
    ) => {
        setIsLoading(true);
        return requests
            .post('/dublin/api/v1/liquidate/overtime-liquidation', model)
            .then((res) => res)
            .catch((err) => {throw err})
            .finally(() => setIsLoading(false));
    };

    return {
        getLiquidatedOvertimeHours,
        isLoading,
        approveOvertimeHours,
        rejectOvertimeHours,
        modifyOvertimeHours,
        overtimeLiquidation,
    };
};
